export const isActiveRoute = (path: string, pathname: string, lang: string) => {
  const normalizedPath = path.replace(/\/$/, '');
  const normalizedPathname = pathname.replace(/\/$/, '');

  if (path === `/${lang}`) {
    return {
      active: pathname === `/${lang}` || pathname === `/${lang}/`,
      clickable: false,
    };
  }

  if (normalizedPath === normalizedPathname) return { active: true, clickable: false };

  if (normalizedPathname.startsWith(normalizedPath)) {
    if (path.includes('games') && pathname.split('/').length === path.split('/').length + 1)
      return { active: true, clickable: false };

    return { active: true, clickable: true };
  }
};

export const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
